import {styled} from "@mui/system";
import {Box, Paper, Typography} from "@mui/material";

export const EmailViewerWrapper = styled(Paper)({
    display: "flex",
    padding: "32px 32px 56px 32px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    borderRadius: "4px",
})
export const DateLine = styled(Typography)({
    alignSelf: "stretch",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
})

export const AddresseeWrapper = styled(Box)({
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    alignSelf: "stretch",
    borderRadius: "12px",
    background: "rgba(253, 196, 0, 0.15)",
})

export const AddresseeText = styled(Typography)({
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
})

export const SubjectWrapper = styled(Box)({
    display: "flex",
    padding: "16px",
    alignItems: "flex-start",
    gap: "8px",
    alignSelf: "stretch",
    borderRadius: "12px",
    background: "rgba(167, 191, 98, 0.20)",
})

export const BodyText = styled(Typography)({
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    whiteSpace: "pre-wrap"
})
